// src/App.tsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Dashboard from './components/Dashboard';
import HomePage from './components/HomePage';
import PetAdoptionPage from './components/PetAdoptionPage';
import PetDetailPage from './components/PetDetailPage'; // Import the new detail page
import PetAdoptionFeedback from './components/PetAdoptionFeedback';
import AdminPanel from './components/AdminPanel';
import AboutUsPage from './components/AboutUsPage';
import './App.css';
import ContactPage from './components/ContactPage';


const App: React.FC = () => (
  <div className="App">
    <Navbar />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/pets" element={<PetAdoptionPage />} />
      <Route path="/pets/:id" element={<PetDetailPage />} /> {/* New route for pet details */}
      <Route path="/testimonials" element={<PetAdoptionFeedback />} />
      <Route path="/AboutUsPage" element={<AboutUsPage />} />
      <Route path="/ContactPage" element={<ContactPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
    </Routes>
    <Footer />
  </div>
);

export default App;